export class ConfigurationForm {
  daysOfTheWeekToApplyDuplication: Array<number>;
  semainierId: string;

  constructor(daysOfTheWeekToApplyDuplication: Array<number>, semainierId: string) {
    this.daysOfTheWeekToApplyDuplication = daysOfTheWeekToApplyDuplication;
    this.semainierId = semainierId;
  }
}
